import * as Api from '@ViewModels';
import { useEmailLikeStepSave, type UseEmailLikeStepSaveOverrides } from './useEmailLikeStepSave';
import type { useAutoSave } from './useAutoSave';

interface UseHtmlNewsletterStepSaveProps {
	newsletterStep: Api.IHtmlNewsletterAutomationStep | null;
	stepId: string;
	templateId: string | undefined;
	name: string;
	tagToAddOnClick: string;
	skipStepContactFilter: Api.IContactsFilterRequest | null | undefined;
	autoSave: ReturnType<typeof useAutoSave>;
}

/** Re-export the overrides type for callers. */
export type UseHtmlNewsletterStepSaveOverrides = UseEmailLikeStepSaveOverrides;

interface UseHtmlNewsletterStepSaveResult {
	save: (overrides?: UseHtmlNewsletterStepSaveOverrides) => Promise<void>;
}

/**
 * Save hook for HtmlNewsletterStepRenderer.
 * Delegates to the shared useEmailLikeStepSave hook.
 */
export function useHtmlNewsletterStepSave({
	newsletterStep,
	stepId,
	templateId,
	name,
	tagToAddOnClick,
	skipStepContactFilter,
	autoSave,
}: UseHtmlNewsletterStepSaveProps): UseHtmlNewsletterStepSaveResult {
	return useEmailLikeStepSave({
		step: newsletterStep,
		stepId,
		stepType: Api.AutomationStepType.HtmlNewsletter,
		templateId,
		name,
		tagToAddOnClick,
		skipStepContactFilter,
		autoSave,
	});
}
